// extracted by mini-css-extract-plugin
export default {"overlay":"AudioStickerOverlay_overlay_afYb9"};